// index.ts
import { CRUDL, installExtension } from "@juitnow/lib-fetch-client";
export * from "../types/validators.mjs";
var RatingsImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/ratings/v1");
  }
  list(query) {
    return this._crudl.list({ ...query });
  }
  create(rating) {
    return this._crudl.create(rating);
  }
  read(uuid) {
    return this._crudl.read(uuid);
  }
  update(uuid, rating) {
    return this._crudl.update(uuid, rating);
  }
  delete(uuid) {
    return this._crudl.delete(uuid);
  }
  async scores(query) {
    if (!query || Object.keys(query).length === 0) {
      const bucket = this._crudl.http.environment === "production" ? "juit-backend-cache-prod" : "juit-backend-cache-dev";
      try {
        const response = await fetch(`https://${bucket}.s3.eu-central-1.amazonaws.com/ratings/scores.json`);
        return await response.json();
      } catch {
      }
    }
    return (await this._crudl.http.get("/ratings/v1/scores", {
      parameters: { ...query }
    })).data;
  }
  async favorites() {
    return (await this._crudl.http.get("/ratings/v1/favorites")).data;
  }
};
installExtension("ratings", RatingsImpl);
export {
  RatingsImpl
};
//# sourceMappingURL=index.mjs.map
